// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"247":"7d20e7e0","622":"7d20e7e0","628":"7d20e7e0","664":"7d20e7e0","851":"7d20e7e0"}[chunkId] + ".chunk.css";
};